<div class="instructor-slides owl-carousel owl-theme">
  <div class="single-instructor-box mb-30">
    <div class="image">
      <img src="/assets/img/instructor/man1.png" alt="image">

      <ul class="social">
        <li><a target="_blank"><i class="bx bxl-facebook"></i></a></li>
        <li><a target="_blank"><i class="bx bxl-twitter"></i></a></li>
        <li><a target="_blank"><i class="bx bxl-linkedin"></i></a></li>
        <li><a target="_blank"><i class="bx bxl-instagram"></i></a></li>
      </ul>
    </div>

    <div class="content">
      <h3><a>Мамбетов Азамат</a></h3>
      <span>Преподаватель кыргызского языка</span>
    </div>
  </div>

  <div class="single-instructor-box mb-30">
    <div class="image">
      <img src="/assets/img/instructor/man2.png" alt="image">

      <ul class="social">
        <li><a target="_blank"><i class="bx bxl-facebook"></i></a></li>
        <li><a target="_blank"><i class="bx bxl-twitter"></i></a></li>
        <li><a target="_blank"><i class="bx bxl-linkedin"></i></a></li>
        <li><a target="_blank"><i class="bx bxl-instagram"></i></a></li>
      </ul>
    </div>

    <div class="content">
      <h3><a>Кыдыр уулу Куштар</a></h3>
      <span>Преподаватель математики</span>
    </div>
  </div>

  <div class="single-instructor-box mb-30">
    <div class="image">
      <img src="/assets/img/instructor/man1.png" alt="image">

      <ul class="social">
        <li><a target="_blank"><i class="bx bxl-facebook"></i></a></li>
        <li><a target="_blank"><i class="bx bxl-twitter"></i></a></li>
        <li><a target="_blank"><i class="bx bxl-linkedin"></i></a></li>
        <li><a target="_blank"><i class="bx bxl-instagram"></i></a></li>
      </ul>
    </div>

    <div class="content">
      <h3><a>Советбек уулу Айболот</a></h3>
      <span>Преподаватель русского языка</span>
    </div>
  </div>
</div>
